import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import CoursePage from "@/pages/CoursePage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/:slug" element={<CoursePage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
                <WhatsAppButton />
                <Toaster
                    position="top-center"
                    richColors
                    closeButton
                    toastOptions={{
                        style: { borderRadius: 0, fontFamily: "IBM Plex Sans" },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
